const trains = {
  train: "Tren", // translated 
  trains: "Mga Tren", // translated 
  fairConditions: "Mga Makatarungang Kondisyon", // translated 
  to: "sa", // translated 
  earlier: "Mas maaga", // translated 
  later: "Mamaya", // translated 
  adults: "Mga Matanda", // translated 
  child: "Bata", // translated 
  senior: "Nakatatanda", // translated 
  seniors: "Mga Senior", // translated 
  price: "Presyo", // translated 
  for: "para sa", // translated 
  total: "Kabuuan", // translated 
  selected: "Napili", // translated 
  prebook: "Prebook", // translated 
  book: "Libro", // translated 
  payment: "Pagbabayad", // translated 
  return: "Pagbabalik", // translated 
  passengers: "Mga Pasahero", // translated 
  delivery: "Paghahatid", // translated 
  summary: "Buod", // translated 
  checkout: "Pag-checkout", // translated 
  trainToastCorrectFillForm: "Pakipunan nang maayos ang lahat ng mga patlang.", // translated 
  fareConditions: "Mga kondisyon ng pamasahe", // translated 
  travelInfo: "Impormasyon sa paglalakbay", // translated 
  remarks: "Mga komento ng customer", // translated 
  noServices: "Walang serbisyo", // translated 
  timesAndSeats: "Mga oras at upuan", // translated 
  mobileTicket: "Tiket sa mobile", // translated 
  stationTicket: "Kunin sa istasyon", // translated 
  homeTicket: "Mag-print sa bahay", // translated 
  countryCode: "Kodigo ng bansa", // translated 
  chooseTicket: "Pumili ng paraan ng paghahatid ng tiket", // translated 
  ticketError: "Pumili ng tiket para sa lahat ng destinasyon", // translated 
  ticketDelivery: "Pumili ng paraan ng paghahatid ng tiket", // translated 
  passengerDetails: "Mga detalye ng pasahero", // translated 
  waitWhileProcessingPayment:
    "Mangyaring maghintay habang pinoproseso namin ang iyong bayad, huwag i-refresh o isara ang pahina.", // translated 
  reductionCardId: "ID ng card ng pagbawas", // translated 
  countryOfResidence: "Bansang tinitirhan", // translated 
  countryOfBirth: "Bansang pinagmulan", // translated 
  documentCountry: "Bansa ng dokumento", // translated 
  documentNumber: "Numero ng dokumento", // translated 
  expirationDate: "Petsa ng pag-expire", // translated 
  documentType: "Uri ng dokumento", // translated 
  travelerDocumentInfo: "Impormasyon sa dokumento ng manlalakbay", // translated 
  youth: "Kabataan", // translated 
  youths: "Mga Kabataan", // translated 
  departTimeEarlyFirst: "Oras ng pag-alis (unang maaga)", // translated 
};


export default trains;
